const data = [
  {
    title: "Do I Need Busseness Plan",
    text: "We Denounce With Righteous Indignation And Dislike Men Who Are So To Beguiled And Demoralized By The Charms Of Pleasure Of The Moment, So Blinded By Desire.",
  },
  {
    title: "How Long Should A Business Pln Be",
    text: "We Denounce With Righteous Indignation And Dislike Men Who Are So To Beguiled And Demoralized By The Charms Of Pleasure Of The Moment, So Blinded By Desire.",
  },
  {
    title: "What Payment Gateway You Support",
    text: "We Denounce With Righteous Indignation And Dislike Men Who Are So To Beguiled And Demoralized By The Charms Of Pleasure Of The Moment, So Blinded By Desire.",
  },
  {
    title: "We Are Many Variations Of Passages",
    text: "We Denounce With Righteous Indignation And Dislike Men Who Are So To Beguiled And Demoralized By The Charms Of Pleasure Of The Moment, So Blinded By Desire.",
  },
  {
    title: "The Majority Have Suffered Alteration",
    text: "We Denounce With Righteous Indignation And Dislike Men Who Are So To Beguiled And Demoralized By The Charms Of Pleasure Of The Moment, So Blinded By Desire.",
  },
  {
    title: "What is your contract address ?",
    text: "We Denounce With Righteous Indignation And Dislike Men Who Are So To Beguiled And Demoralized By The Charms Of Pleasure Of The Moment, So Blinded By Desire.",
  },
];

export default data;
